import $ from 'jquery'
import Base from 'luminate/src/modules/base'
import {dependency} from '../utilities'
import Init from '../init'

const parsleyDir = 'https://cdnjs.cloudflare.com/ajax/libs/parsley.js/2.5.1/'

export default Base.extend({
	directive: 'form-validator',

	defaults: {

	},

	events: {

		init: function()
		{
			dependency(parsleyDir + 'parsley.min.js', () =>
			{
				const $element = $(this.$element)
				const parsley = $element.parsley()

				parsley.on('field:validated', e =>
				{
					// Make sure errors reported by the server get removed
					$element.siblings('.float-label_errors').remove()
				})

			}, () => window.Parsley)
		}
	}
})



/** WEBPACK FOOTER **
 ** ./source/scripts/modules/form-validator.js
 **/